import { Navigate } from "react-router"
import Login from "../component/auth/Login"
import Register from "../component/auth/Register"
import adminRoutesConfig from "../config/adminRoutesConfig"
import TrackCourier from "../component/TrackingPage/TrackCourier"
import TrackCourierRedirect from "../component/TrackingPage/TrackCourierRedirect"

const routesConfig = [
  {
    path: "/",
    element: <Navigate to="/login" replace />,
  },
  {
    path:'/index.html',
    element: <Login/>,
  },
  {
    path: "/login",
    element: <Login />,
  },
  {
    path: "/register",
    element: <Register />,
  },
  {
    path: "/track/:trackingId",
    element: <TrackCourier />,
  },
  {
    path: "/track",
    element: <TrackCourierRedirect />,
  },
  adminRoutesConfig,
]

export default routesConfig
